const colorSelectorEl = document.querySelector('.block-detail--color-selector');
const colorSelectorCurrentEl = document.querySelector('.block-detail--color-selector-current');
const colorSelectorListEl = document.querySelector('.block-detail--color-selector-list');

class VariantSelectsColor extends HTMLElement {
  constructor() {
    super();
    this.showOptions = this.showOptions.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
    colorSelectorCurrentEl.addEventListener('click', this.showOptions);
    colorSelectorListEl.addEventListener('click', this.onVariantChange);
  }

  showOptions() {
    if (colorSelectorListEl.classList.contains('hidden')) {
      colorSelectorListEl.classList.remove('hidden');
    } else {
      colorSelectorListEl.classList.add('hidden');
    }
  }

  onVariantChange(e) {
    this.updateCurrentOption(e);
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateCurrentOption(e) {
    // カラー名を変更
    const colorSelectorCurrentNameEl = colorSelectorCurrentEl.querySelector('.block-detail--color-selector-color-name');
    const target = e.target.closest('.block-detail--color-selector-list-item').getAttribute('data-target');
    if (colorSelectorCurrentNameEl) {
      colorSelectorCurrentNameEl.textContent = target;
    }
    // カラーサムネイルの色を変更
    const colorSelectorCurrentImageCircleEl = colorSelectorCurrentEl.querySelector('.block-detail--color-selector-color-image-circle');
    if (colorSelectorCurrentImageCircleEl) {
      const colorCode = e.target.closest('.block-detail--color-selector-list-item').getAttribute('data-color-code');
      colorSelectorCurrentImageCircleEl.style.backgroundColor = colorCode;
    }
    // selected属性を変更
    const listItems = colorSelectorListEl.querySelectorAll('.block-detail--color-selector-list-item');
    listItems.forEach((item) => {
      if (item.getAttribute('data-target') === target) {
        item.setAttribute('selected', 'selected');
      } else {
        item.removeAttribute('selected');
      }
    });
    colorSelectorListEl.classList.add('hidden');
  }

  updateOptions() {
    this.options = [colorSelectorListEl.querySelector("[selected=selected]").getAttribute("data-target")];
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      // 先行予約時の文言
      if (window.productMetafields.preSale && window.productMetafields.todaySecond < window.productMetafields.preSale) {
        addButtonText.textContent = window.variantStrings.preSale;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects-color", VariantSelectsColor);